module.exports = __webpack_public_path__ + "img/tile-2.1ce99dce.svg";